import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
} from '@mui/material';

import LoadingButton from '@mui/lab/LoadingButton';
import { v4 as uuidv4 } from 'uuid';
import { gcoreServerUrl, fileServerUrl} from '../../config';
import { FormInputDate, FormInputText } from "../form";
import {
  AlertDialog,
  ConfirmDialog,
  DialogTitleClose,
  PaperComponent,
} from "../dialog";
import * as dateUtils from '../../utils/dateUtils';
import { csrfFetch } from "../../store/csrf.js";

const today = new Date();

// 아래 form components의 name과 연계
const defaultValues = {
  endDate: today,
};

const ExpiredExcelDownDialog = ({
  open,
  setOpen,
}) => {

  const [alertInfo, setAlertInfo] = useState({});
  const [isDownloading, setIsDownloading] = useState(false);

  const { control, setValue, getValues } = useForm({ defaultValues: defaultValues });

  useEffect(
    () => {
      if (open) {
        initDialog();
      }
    }, [open]
  );

  const initDialog = () => {
    setValue("endDate", today);
  };

  const handleDialogClose = () => {
    setValue("endDate", today);
    setOpen(false);
  };

  const handleChangePeriod = (value, name) => {
    console.log({ name, value })
    setValue(name, value);
    // if (name === "endDate") {
    //   setEndDate(value);
    // }
    return true;
  }

  const handleExcelDownload = async () => {
    try {
      setIsDownloading(true);
      const id = 'EQ0001';
      const endDateStr = dateUtils.dateFormat(getValues("endDate"), 'yyyyMMdd');

      if (!endDateStr) {
        setAlertInfo({
          titleAlert: "경고",
          messageAlert: "서류 만료일을 선택해주세요.",
          open: true,
        });
        return;
      }

      console.log('요청 데이터:', { id, args: [endDateStr, endDateStr, endDateStr, endDateStr] });

      const response = await csrfFetch(null, `${gcoreServerUrl}/api/exceldata/download`, {
        method: "POST",
        body: JSON.stringify({ id, args: [endDateStr, endDateStr, endDateStr, endDateStr] }),
      });

      console.log('응답 상태:', response.status);
      console.log('응답 헤더:', Object.fromEntries(response.headers.entries()));

      if (!response.ok) {
        const errorText = await response.text();
        console.error('서버 오류 응답:', errorText);
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      // Content-Type 확인
      const contentType = response.headers.get('Content-Type');
      console.log('Content-Type:', contentType);

      if (!contentType || !contentType.includes('spreadsheetml') && !contentType.includes('excel')) {
        // Excel 파일이 아닌 경우 텍스트로 읽어서 확인
        const textResponse = await response.text();
        console.error('Excel이 아닌 응답:', textResponse);
        throw new Error('서버에서 Excel 파일이 아닌 응답을 받았습니다.');
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      // 파일명 고정
      const filename = `만료된_서류현황_${endDateStr}.xlsx`;
      
      const blob = await response.blob();

      // 파일 다운로드
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.style.display = 'none';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // URL 해제
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100);
  

      // setAlertInfo({
      //   titleAlert: "완료",
      //   messageAlert: "엑셀 파일이 다운로드되었습니다.",
      //   open: true,
      // });

    } catch (error) {
      console.error('Excel 다운로드 중 오류:', error);
      setAlertInfo({
        titleAlert: "오류",
        messageAlert: "엑셀 다운로드 중 오류가 발생했습니다.",
        open: true,
      });
    } finally {
      setIsDownloading(false);
    }
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleDialogClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        fullWidth={true}
        maxWidth="xs"
      >
        <DialogTitleClose
          id="draggable-dialog-title"
          // onClose={handleDialogClose}
          style={{ cursor: 'move' }}
        >
          {`만료된 서류현황 엑셀 다운로드`}
        </DialogTitleClose>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <FormInputDate
                    name="endDate"
                    control={control}
                    label={"서류 만료일"}
                    onChangePeriodValue={handleChangePeriod}
                    value={getValues("endDate")}
                    setValue={setValue}
                    getValues={getValues}
                    inputHeight={38}
                    clearable={true}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" display="block" gutterBottom sx={{ mt: 3, color: 'primary.main' }}>
                    &#8251;&nbsp;{"설정한 일자를 기준으로,"}<br />
                    &nbsp;&nbsp;&nbsp;{"이미 만료되었거나 만료되는 서류 목록을 검색합니다."}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <LoadingButton 
              onClick={handleExcelDownload}
              loading={isDownloading}
              variant="contained"
              color="primary"
            >
              {isDownloading ? "다운로드 중..." : "엑셀 다운로드"}
          </LoadingButton>
          <Button onClick={handleDialogClose}>{"닫기"}</Button>
        </DialogActions>
      </Dialog>
      <AlertDialog
        alertInfo={alertInfo}
        setAlertInfo={setAlertInfo}
      />
    </>
  );
};

export default ExpiredExcelDownDialog;
